export const title = 'Historial de validaciones';
export const details = 'Detalles';
export const detail = 'Detalle';
